import { IVoucherHolderForList } from '@nkr/models/index';
import { AdpVoucherHolderStatus, VoucherHolderType } from '@nkr/enums/index';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';
import ReactHtmlParser from 'react-html-parser';

export enum VoucherHolderAction {
    Edit = 1,
    OrderBuccalSwabKit = 2,
    OrderLabScreening = 3,
    StartRedemption = 4,
    UploadVoucherConsent = 5,
    UploadSwabResults = 6,
    UploadScreeningResults = 7,
    ResendLink = 9
}

const menuItemList = [
    { action: VoucherHolderAction.Edit, title: 'Edit' },
    { action: VoucherHolderAction.OrderBuccalSwabKit, title: 'Order Buccal Swab Kit' },
    { action: VoucherHolderAction.OrderLabScreening, title: 'Order Lab Screening' },
    { action: VoucherHolderAction.ResendLink, title: 'Re-send Invite' },
    { action: VoucherHolderAction.StartRedemption, title: 'Start Redemption' },
    { action: VoucherHolderAction.UploadVoucherConsent, title: 'Upload Voucher Consent' },
    { action: VoucherHolderAction.UploadSwabResults, title: 'Upload Swab Results' },
    { action: VoucherHolderAction.UploadScreeningResults, title: 'Upload Screening Results' },
    { action: -1, title: '' }
];

interface IProps {
    data: IVoucherHolderForList,
    isAdmin: boolean,
    isAdminLogin: boolean,
    donorHasDonated: boolean,
    pullRight?: boolean,
    onMenuDisplayed?: (id: number) => void,
    onMenuToggle: (show: boolean) => void,
    onItemSelected: (id: number, action: number) => void
}

const ActionButtonRenderer = (props: IProps) => {
    const handleMenuToggle = (show: boolean) => {
        props.onMenuToggle(show);
    };

    const handleMenuSelection = (id: any, action: number) => {
        props.onItemSelected(id, action);
    };

    const getUrl = (action: number, id: number) => {
        let hrefPrefix = props.isAdmin ? '/admin/donor' : `/center/${props.data.donorCenterId}/donor`;

        switch (action) {
            case VoucherHolderAction.Edit: return `${hrefPrefix}/${props.data.donorId}/voucher/${id}`;
        }

        return null;
    };

    const getMenuItems = () => {
        let data = props.data as IVoucherHolderForList;

        let menuItems = [];

        menuItems.push(VoucherHolderAction.Edit);

        if (data.statusId == AdpVoucherHolderStatus.Available) {
            if (props.isAdminLogin && data.typeId != VoucherHolderType.StandardVoucher) {
                menuItems.push(-1);
                menuItems.push(VoucherHolderAction.OrderBuccalSwabKit);
                menuItems.push(VoucherHolderAction.OrderLabScreening);
            }

            menuItems.push(-1);
            menuItems.push(VoucherHolderAction.StartRedemption);
        }

        if (!props.data.donorDonated) {
            menuItems.push(-1);
            menuItems.push(VoucherHolderAction.ResendLink);
        }

        menuItems.push(-1);

        if (props.isAdminLogin || (props.isAdminLogin == false && props.donorHasDonated == false)) {
            menuItems.push(VoucherHolderAction.UploadVoucherConsent);
        }

        if (props.isAdminLogin && data.typeId != VoucherHolderType.StandardVoucher) {
            menuItems.push(VoucherHolderAction.UploadSwabResults);
        }

        if (data.typeId != VoucherHolderType.StandardVoucher) {
            menuItems.push(VoucherHolderAction.UploadScreeningResults);
        }

        return menuItems;
    };

    const menuItems = getMenuItems().map(item => {
        return menuItemList.find(x => x.action == item);
    });

    const menu = menuItems.map(item => {
        let url = item.action != -1 ? getUrl(item.action, props.data.id) : null;
        let id = item.action >= 0 ? props.data.id : 'div-' + props.data.id + '-' + Math.random() * 10000;

        if (url == null) {
            if (item.action >= 0) {
                return { id, action: item.action, include: true, selectable: true, url, element: <div>{ReactHtmlParser(item.title.replace(/ /g, '&nbsp;'))}</div> };
            } else {
                return { id, action: item.action, include: true, selectable: false, url, element: <div style={{ height: 10 }}></div>, divider: true };
            }
        } else {
            return { id, action: item.action, include: true, selectable: false, url, element: <a href={url}>{ReactHtmlParser(item.title.replace(/ /g, '&nbsp;'))}</a> };
        }
    });

    return (
        <div style={{ width: '100%', textAlign: 'center' }}>
            <OverlayMenuButton
                menu={menu}
                bsStyle='primary'
                bsSize='xs'
                title='Actions'
                listItemStyle={{ padding: '2px 7.5px', fontSize: 14 }}
                includeCaret={true}
                width={200}
                onToggle={handleMenuToggle}
                onSelect={handleMenuSelection}
            />
        </div>
    );
}

export default ActionButtonRenderer;